<template>
  <div class="steps">
    <div v-for="step in steps" :key="step.step" :class="['step-item', {'active': current >= step.step}, {'active-prev': current > step.step}]">
      <div class="icon-title">
        <sass-icon
          :type="current >= step.step ? `${step.iconActive}` : `${step.icon}`"
          :style="{ fontSize: `${iconSize}px`, color: current < step.step ? 'rgba(0, 0, 0, 0.45)' : ''}"
        />
        <p class="title" :style="{color: `${ current < step.step ? 'rgba(0, 0, 0, 0.45)' : '' }`}">{{ step.title }}</p>
      </div>
      <div class="dot-line">
        <span class="dot"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Steps',
  props: {
    iconSize: {
      type: Number,
      default: 40
    },
    current: {
      type: Number,
      default: 1
    },
    steps: {
      type: Array,
      required: true
    }
  }
}
</script>
<style lang="less" scoped>
@import "~ant-design-vue/lib/style/index";
.steps {
  display: flex;
  justify-content: space-around;
}
.icon-title {
  text-align: center;
  // border: 1px solid red;
  .title {
    margin-top: 8px;
    // border: 1px solid red;
  }
}
.dot-line {
  position: relative;
  margin-top: 12px;
  text-align: center;
  &::before {
    position: absolute;
    bottom: 12px;
    left: 0;
    width: calc(50% - 8px);
    height: 2px;
    background: #f5f5f5;
    content: '';
  }
  &::after {
    position: absolute;
    right: 0;
    bottom: 12px;
    width: calc(50% - 8px);
    height: 2px;
    background: #f5f5f5;
    content: '';
  }
}
.dot {
  display: inline-block;
  box-sizing: border-box;
  border: 2px solid #fff;
  border-radius: 7.5px;
  width: 14px;
  height: 14px;
  background: #e5e5e5;
}
.step-item {
  flex: 1;
  &.active {
    .dot {
      background: @primary-color;
    }
    .dot-line {
      &::before {
        background: @primary-color;
      }
    }
  }
  &.active-prev {
    .dot-line {
      &::after {
        background: @primary-color;
      }
    }
  }
  &:first-child {
    .dot-line {
      &::before {
        content: none;
      }
    }
  }
  &:last-child {
    .dot-line {
      &::after {
        content: none;
      }
    }
  }
}
</style>
